import Vue from "vue";
import VueRouter from "vue-router";
// import { storage } from "../utils/public";
import { clearPending } from "../utils/request";
import Login from "../views/login/index.vue";
import Admin from "../views/admin/index.vue";
const NewList = () => import("../views/admin/newList.vue");
const NewInfo = () => import("../views/admin/newInfo.vue");
const NotFound = () => import("../views/errorPage/404.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Login
  },
  {
    path: "/admin",
    component: Admin,
    // beforeEnter: (to, from, next) => {
    //   const hasToken = storage.getSession("token");
    //   if (hasToken) {
    //     next();
    //   } else {
    //     next({ path: "/" });
    //   }
    // },
    children: [
      {
        path: "",
        redirect: "/newList"
      },
      {
        path: "newList",
        component: NewList,
        alias: "/newList"
      },
      {
        path: "newInfo/:method",
        component: NewInfo,
        alias: "/newInfo/:method"
      }
    ]
  },
  {
    path: "*",
    redirect: "/404"
  },
  {
    path: "/404",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes
});

router.beforeEach((to, from, next) => {
  clearPending();
  next();
});

export default router;
